import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
import media from './media'
/**
* @see \App\Http\Controllers\Settings\MenuController::index
* @see app/Http/Controllers/Settings/MenuController.php:18
* @route '/admin/marketing/site-menu'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin/marketing/site-menu',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Settings\MenuController::index
* @see app/Http/Controllers/Settings/MenuController.php:18
* @route '/admin/marketing/site-menu'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Settings\MenuController::index
* @see app/Http/Controllers/Settings/MenuController.php:18
* @route '/admin/marketing/site-menu'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Settings\MenuController::index
* @see app/Http/Controllers/Settings/MenuController.php:18
* @route '/admin/marketing/site-menu'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Settings\MenuController::index
* @see app/Http/Controllers/Settings/MenuController.php:18
* @route '/admin/marketing/site-menu'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Settings\MenuController::index
* @see app/Http/Controllers/Settings/MenuController.php:18
* @route '/admin/marketing/site-menu'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Settings\MenuController::index
* @see app/Http/Controllers/Settings/MenuController.php:18
* @route '/admin/marketing/site-menu'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Settings\MenuController::store
* @see app/Http/Controllers/Settings/MenuController.php:31
* @route '/admin/marketing/site-menu'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/admin/marketing/site-menu',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Settings\MenuController::store
* @see app/Http/Controllers/Settings/MenuController.php:31
* @route '/admin/marketing/site-menu'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Settings\MenuController::store
* @see app/Http/Controllers/Settings/MenuController.php:31
* @route '/admin/marketing/site-menu'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Settings\MenuController::store
* @see app/Http/Controllers/Settings/MenuController.php:31
* @route '/admin/marketing/site-menu'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Settings\MenuController::store
* @see app/Http/Controllers/Settings/MenuController.php:31
* @route '/admin/marketing/site-menu'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Settings\MenuController::reorder
* @see app/Http/Controllers/Settings/MenuController.php:113
* @route '/admin/marketing/site-menu/reorder'
*/
export const reorder = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reorder.url(options),
    method: 'post',
})

reorder.definition = {
    methods: ["post"],
    url: '/admin/marketing/site-menu/reorder',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Settings\MenuController::reorder
* @see app/Http/Controllers/Settings/MenuController.php:113
* @route '/admin/marketing/site-menu/reorder'
*/
reorder.url = (options?: RouteQueryOptions) => {
    return reorder.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Settings\MenuController::reorder
* @see app/Http/Controllers/Settings/MenuController.php:113
* @route '/admin/marketing/site-menu/reorder'
*/
reorder.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reorder.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Settings\MenuController::reorder
* @see app/Http/Controllers/Settings/MenuController.php:113
* @route '/admin/marketing/site-menu/reorder'
*/
const reorderForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reorder.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Settings\MenuController::reorder
* @see app/Http/Controllers/Settings/MenuController.php:113
* @route '/admin/marketing/site-menu/reorder'
*/
reorderForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reorder.url(options),
    method: 'post',
})

reorder.form = reorderForm

/**
* @see \App\Http\Controllers\Settings\MenuController::update
* @see app/Http/Controllers/Settings/MenuController.php:62
* @route '/admin/marketing/site-menu/{menuItem}'
*/
export const update = (args: { menuItem: string | number | { id: string | number } } | [menuItem: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/admin/marketing/site-menu/{menuItem}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Settings\MenuController::update
* @see app/Http/Controllers/Settings/MenuController.php:62
* @route '/admin/marketing/site-menu/{menuItem}'
*/
update.url = (args: { menuItem: string | number | { id: string | number } } | [menuItem: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { menuItem: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { menuItem: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            menuItem: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        menuItem: typeof args.menuItem === 'object'
        ? args.menuItem.id
        : args.menuItem,
    }

    return update.definition.url
            .replace('{menuItem}', parsedArgs.menuItem.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Settings\MenuController::update
* @see app/Http/Controllers/Settings/MenuController.php:62
* @route '/admin/marketing/site-menu/{menuItem}'
*/
update.put = (args: { menuItem: string | number | { id: string | number } } | [menuItem: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Settings\MenuController::update
* @see app/Http/Controllers/Settings/MenuController.php:62
* @route '/admin/marketing/site-menu/{menuItem}'
*/
const updateForm = (args: { menuItem: string | number | { id: string | number } } | [menuItem: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Settings\MenuController::update
* @see app/Http/Controllers/Settings/MenuController.php:62
* @route '/admin/marketing/site-menu/{menuItem}'
*/
updateForm.put = (args: { menuItem: string | number | { id: string | number } } | [menuItem: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Settings\MenuController::destroy
* @see app/Http/Controllers/Settings/MenuController.php:101
* @route '/admin/marketing/site-menu/{menuItem}'
*/
export const destroy = (args: { menuItem: string | number | { id: string | number } } | [menuItem: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/admin/marketing/site-menu/{menuItem}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Settings\MenuController::destroy
* @see app/Http/Controllers/Settings/MenuController.php:101
* @route '/admin/marketing/site-menu/{menuItem}'
*/
destroy.url = (args: { menuItem: string | number | { id: string | number } } | [menuItem: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { menuItem: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { menuItem: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            menuItem: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        menuItem: typeof args.menuItem === 'object'
        ? args.menuItem.id
        : args.menuItem,
    }

    return destroy.definition.url
            .replace('{menuItem}', parsedArgs.menuItem.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Settings\MenuController::destroy
* @see app/Http/Controllers/Settings/MenuController.php:101
* @route '/admin/marketing/site-menu/{menuItem}'
*/
destroy.delete = (args: { menuItem: string | number | { id: string | number } } | [menuItem: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Settings\MenuController::destroy
* @see app/Http/Controllers/Settings/MenuController.php:101
* @route '/admin/marketing/site-menu/{menuItem}'
*/
const destroyForm = (args: { menuItem: string | number | { id: string | number } } | [menuItem: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Settings\MenuController::destroy
* @see app/Http/Controllers/Settings/MenuController.php:101
* @route '/admin/marketing/site-menu/{menuItem}'
*/
destroyForm.delete = (args: { menuItem: string | number | { id: string | number } } | [menuItem: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const siteMenu = {
    index: Object.assign(index, index),
    store: Object.assign(store, store),
    reorder: Object.assign(reorder, reorder),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
    media: Object.assign(media, media),
}

export default siteMenu